import { $vfm } from 'vue-final-modal'
import SelectAuctionsModal from "../Modals/SelectAuctionsModal.vue"

export default function useSelectCategoriesModal(callback) {

  const close = () => {
    $vfm.hideAll().then(r => {})
  }

  const open = () => {
    $vfm.show({
      component: SelectAuctionsModal,
      bind: { callback, close }
    })
  }

  return {
    open,
    close
  }
}
